import { Box, Typography } from '@mui/material';
export default function AdminFooter() {
  return (
    <Box 
      component="footer"
      sx={{ 
        py: 2,
        px: 3,
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        textAlign: 'center'
      }}
    >
      <Typography variant="body2" color="text.secondary">
        © {new Date().getFullYear()} Koufuku International Limited. All rights reserved.
      </Typography>
    </Box>
  );
}